module.exports = __webpack_public_path__ + "distribution/img/ico3.21576c0e.png";